module.exports = __webpack_public_path__ + "media/components/src/assets/images/sentiment/sentiment-a00a10ef14fae5afb46f96a8fa223e96.svg";